import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Text} from "./Text";

interface BadgeProps {
  type?: string;
  text: string | number;
  minWidth?: string;
  marginRight?: string;
  marginLeft?: string;
  textSize?: 'small' | 'small-medium' | 'medium' | 'large';
  textWeight?: 'normal' | 'bold' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900';
}

interface BadgeContainerProps {
  backgroundColour: string;
  textColour: string;
  minWidth?: string;
  marginRight?: string;
  marginLeft?: string;
}

const Badge = ({type, text, minWidth, marginRight, marginLeft , textSize, textWeight}: BadgeProps) => {
  const [bgColour, setBgColour] = useState('');
  const [textColour, setTextColour] = useState('');

  // add more colours if needed
  const setBadgeColour = () => {
    switch (type) {
      case 'info':
        setBgColour('#DADADA');
        setTextColour('#000000');
        break;
      case 'warning':
        setBgColour('#FFCA28');
        setTextColour('#000000');
        break;
      case 'default':
        setBgColour('#FFFFFF');
        setTextColour('#323232');
        break;
    }
  }

  useEffect(() => {
    setBadgeColour();
  }, [bgColour]);



    return (
        <BadgeContainer
            backgroundColour={bgColour}
            textColour={textColour}
            minWidth={minWidth}
            marginRight={marginRight}
            marginLeft={marginLeft}
        >
          <Text size={textSize} weight={textWeight}>{text}</Text>
        </BadgeContainer>
    )
}

const BadgeContainer = styled.div<BadgeContainerProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.backgroundColour};
    padding: 5px 20px;
    margin: 0 ${(props) => props.marginRight || '5px'} 0 ${(props) => props.marginLeft || '5px'}; // Use provided marginRight or marginLeft or default
    border-radius: 999em;
    color: ${(props) => props.textColour};
    font-weight: bold;
    font-size: 13px;
    ${(props) => props.minWidth && `min-width: ${props.minWidth}`};
`

export default Badge;

